.truncate {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

/*
 * Palmetto toasts are a fixed-width (max 300px) flex row, so a long unbreakable token — an email,
 * URL, or id with no spaces — can't wrap and gets clipped at the edge (see e.g. the "already claimed
 * by <email>" alert). Target palmetto's own `toast-notification` element and its children:
 * `overflow-wrap: anywhere` lets the token break, and `min-width: 0` overrides the default
 * `min-width: auto` on the message flex child so it can shrink instead of forcing the overflow.
 */
[class*='toast-notification'],
[class*='toast-notification'] * {
  min-width: 0;
  overflow-wrap: anywhere;
}

a,
a:visited {
  color: var(--color-text-contrast);
  text-decoration-color: var(--color-text-body-primary);
  transition: text-decoration-color 0.3s;
}

a:hover {
  text-decoration: underline;
  text-decoration-color: var(--color-text-contrast);
}

.nav-link,
.nav-link:visited {
  color: var(--color-text-contrast);
  text-decoration: none;
}

.nav-link:hover {
  text-decoration: underline;
}

.tab-active {
  border-bottom: 2px solid var(--color-text-primary);
  color: var(--color-text-primary);
}

.milestone-tab {
  outline: none;
}

.milestone-tab:focus-visible {
  outline: 2px solid var(--color-text-primary);
  outline-offset: -2px;
  border-radius: 2px;
}

.skeletonBox {
  position: relative;
  overflow: hidden;
}

.skeletonBox::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 2s infinite;
  content: '';
}

.fade-in {
  animation: fadeIn 0.3s;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media screen and (min-width: 680px) {
  .arrow-box:after,
  .arrow-box:before {
    left: 100%;
    top: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    z-index: 1;
  }

  .arrow-box:after {
    border-color: rgba(136, 183, 213, 0);
    border-left-color: var(--color-border-separator);
    border-width: 8px;
    margin-top: -8px;
  }
  .arrow-box:before {
    border-color: rgba(194, 225, 245, 0);
    border-left-color: var(--color-border-separator);
    border-width: 10px;
    margin-top: -10px;
  }
  .border-out {
    border-width: 0 0 0 0;
  }
  .document-name {
    font-size: medium;
    font-weight: bold;
    color: gray;
    text-decoration: none;
    :visited {
      text-decoration: none;
    }
    :hover {
      text-decoration: none;
    }
    :active {
      text-decoration: none;
    }
    :link {
      text-decoration: none;
    }
  }
}
